import { instance } from "../axios"
import type { AxiosRequestConfig } from "axios"

// 取得會員列表
export function getMemberList(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/members/",
        method: "get",
        ...config,
    })
}

// 取得會員詳細資料
export function getMemberDetail(
    memberId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/members/${memberId}/`,
        method: "get",
        ...config,
    })
}

// 更新會員詳細資料
export function updateMemberDetail(
    memberId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/members/${memberId}/`,
        method: "put",
        ...config,
    })
}

// 更新會員部分詳細資料
export function patchMemberDetail(
    memberId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/members/${memberId}/`,
        method: "patch",
        ...config,
    })
}

// 更新會員封鎖狀態
export function patchMemberBlocking(
    memberUuid: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/members/${memberUuid}/block-info/`,
        method: "patch",
        ...config,
    })
}

// 更新會員封鎖狀態
export function updateMemberBlocking(
    memberUuid: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/members/${memberUuid}/block-info/`,
        method: "put",
        ...config,
    })
}

// 取得會員活動列表
export function getMemberEvents(
    memberId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/members/${memberId}/events/`,
        method: "get",
        ...config,
    })
}

// 取得會員旅程活動列表
export function getMemberJourneyEvents(
    memberId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/members/${memberId}/journey-events/`,
        method: "get",
        ...config,
    })
}

// 取得會員標籤列表
export function getMemberTags(
    memberId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/members/${memberId}/tags/`,
        method: "get",
        ...config,
    })
}

// 取得會員備註列表
export function getMemberNotes(
    memberId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/members/${memberId}/notes/`,
        method: "get",
        ...config,
    })
}

// 建立會員備註列表
export function addMemberNotes(
    memberId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/members/${memberId}/notes/`,
        method: "post",
        ...config,
    })
}
